/*
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-06-29 16:16:17
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-28 16:56:40
 */

import lodash from 'lodash'

/**
 * 深度拷贝对象
 * @param {*} obj
 * @returns
 */
export const deepClone = (obj = {}) => {
  return lodash.cloneDeep(obj)
}

export const isEmpty = (val) => {
  if (val && parseInt(val) === 0) return false
  if (
    typeof val === 'undefined' ||
    val === 'null' ||
    val == null ||
    val === 'undefined' ||
    val === undefined ||
    val === ''
  ) {
    return true
  } else if (typeof val === 'object' && Object.keys(val).length === 0) {
    return true
  } else if (val instanceof Array && val.length === 0) {
    return true
  } else {
    return false
  }
}

// 创建id
export const createId = (prefix) => {
  let val = Date.now() + Math.ceil(Math.random() * 99999)
  return isEmpty(prefix) ? val + '' : prefix + '-' + val
}

// 根据type返回相应的数组
export const getArrayByType = (arr, type) => {
  if (isEmpty(arr) || isEmpty(type)) return []
  let list = arr.filter((item) => {
    return item.attribute === type
  })
  return list
}

// 合并数组
export const getArrayByConcat = (...arr) => {
  return lodash.concat([], ...arr)
}

// 数据差集
export const getArrayByExcept = (...arr) => {
  return lodash.xor(...arr)
}

// 数组交集
export const getArrayByIntersection = (...arr) => {
  return lodash.intersection(...arr)
}

/**
 * 特定查询条件树根据pid递归寻找parent
 * @param {*} arr
 * @param {*} pid
 * @returns
 */
export const getParentByPid = (arr = [], pid) => {
  if (isEmpty(arr) || isEmpty(pid)) return null
  let parent = null
  arr.forEach((item) => {
    if (item.id === pid) {
      parent = item
      return
    }
    if (!isEmpty(item.reqParamConditionsModels)) {
      parent = getParentByPid(item.reqParamConditionsModels, pid)
    }
  })
  return parent
}
